import { render, staticRenderFns } from "./UserPackage.vue?vue&type=template&id=7ccb7fc4&scoped=true"
import script from "./UserPackage.vue?vue&type=script&lang=js"
export * from "./UserPackage.vue?vue&type=script&lang=js"
import style0 from "./UserPackage.vue?vue&type=style&index=0&id=7ccb7fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb7fc4",
  null
  
)

export default component.exports